import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import H1Font from "Root/profile/components/common/H1Font";
import RegFont from "Root/profile/components/common/RegFont";
import UnderlinedButton from "Root/profile/components/common/UnderlinedButton";
import styles from "./styles.module.scss";
import React from "react";
const buttons = [
    {
        text: "In store at Target",
        value: "target_store",
    },
    {
        text: "On target.com",
        value: "target_online",
    },
];
const TargetPurchaseSelect = ({ value, setValue }) => {
    const setAnswer = (btnValue) => {
        setValue([btnValue]);
    };
    const goToShop = () => {
        window.open("https://www.target.com/b/gainful/-/N-q643lec1mos");
    };
    return (_jsxs("div", { className: styles.target_purchase, children: [_jsx(H1Font, { children: "Let\u2019s Get Started" }), _jsx(RegFont, { children: "Where did you purchase your Gainful products from?" }), _jsx("div", { className: styles.btns, children: buttons.map((item) => (_jsxs("button", { className: [styles.btn, value.includes(item.value) ? styles.active : ""].join(" "), onClick: () => setAnswer(item.value), type: "button", children: [_jsx("div", { children: _jsxs("svg", { width: "41", height: "42", viewBox: "0 0 41 42", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.5 35.35C28.4253 35.35 34.85 28.9253 34.85 21C34.85 13.0747 28.4253 6.65 20.5 6.65C12.5747 6.65 6.15 13.0747 6.15 21C6.15 28.9253 12.5747 35.35 20.5 35.35ZM20.5 41.5C31.8218 41.5 41 32.3218 41 21C41 9.67816 31.8218 0.5 20.5 0.5C9.17816 0.5 0 9.67816 0 21C0 32.3218 9.17816 41.5 20.5 41.5Z", fill: "#BB271A" }), _jsx("circle", { cx: "20.4998", cy: "21", r: "8.2", fill: "#BB271A" })] }) }), _jsx(RegFont, { children: item.text })] }, item.value))) }), _jsxs("div", { className: styles.footer, children: [_jsx(RegFont, { children: "Don\u2019t have Gainful products yet?" }), _jsx(UnderlinedButton, { onClick: goToShop, label: "shop on target.com" })] })] }));
};
export default TargetPurchaseSelect;
